// Redux
import { createSelector, DuckSelector, objectDuckCreator } from '@atc/modular-redux';

import { VrsServiceClient } from 'reaxl-wallet';

import { bapDuckPreset } from '@/ducks/presets';

import VrsServiceFetcher from '@/fetchers/VrsServiceFetcher';

const bapKbbFairMarketRangeDuck = objectDuckCreator({
    ...bapDuckPreset,
    store: 'kbbFairMarketRange',
    initialState: {
        rangeLow: '',
        rangeHigh: '',
    },
}).extend({
    creators: () => ({
        loadFairMarketRanges: ({ zip, vehicleId, selectedOptions }) => async (dispatch) => {
            const valuationDate = new Date().toLocaleDateString('en-US', { timeZone: 'America/New_York' });
            const selectedOptionIds = selectedOptions && Object.entries(selectedOptions).reduce((acc, [key, opt]) => {
                if (opt?.vehicleOptionId) {
                    acc.push(opt?.vehicleOptionId);
                }
                return acc;
            }, []);

            if (vehicleId) {
                // pass zip,vehicleId,valuationDate and vehicleOptionIds to fetch Fair Market Range
                const vrsServices = new VrsServiceClient({ vrsFetcher: VrsServiceFetcher });
                const fairMarketRangeResponse = await vrsServices.getVehicleValuation({
                    configuration: {
                        vehicleId,
                        vehicleOptionIds: selectedOptionIds,
                    },
                    zipCode: zip,
                    valuationDate,
                });

                const prices = fairMarketRangeResponse && Array.isArray(fairMarketRangeResponse.prices) && fairMarketRangeResponse.prices;
                const fairMarketRange = prices && prices.reduce((acc, opt) => {
                    if (opt?.priceType === 'NCBB') {
                        return {
                            rangeLow: opt?.rangeLow,
                            rangeHigh: opt?.rangeHigh,
                        };
                    }
                    return {};
                }, {});
                await dispatch(bapKbbFairMarketRangeDuck?.creators?.setKeys({
                    rangeLow: fairMarketRange?.rangeLow,
                    rangeHigh: fairMarketRange?.rangeHigh,
                }));
            }
        },
    }),

    selectors: () => ({
        getKbbFairMarketRange: new DuckSelector((selectors) => createSelector(
            selectors.getDuckState,
            (rangeLow) => rangeLow,
            (rangeHigh) => rangeHigh,
        )),
    }),
});

export default bapKbbFairMarketRangeDuck;
